<template>
  <div class="difficulty-learning-area-icon">
    <NetworkingExpert v-if="badge === 'Networking-expert'" />
    <NetworkingProfessional v-if="badge === 'Networking-professional'" />
    <NetworkingAdvanced v-if="badge === 'Networking-advanced'" />
    <NetworkingNovice v-if="badge === 'Networking-novice'" />
    <CloudExpert v-if="badge === 'Cloud-expert'" />
    <CloudProfessional v-if="badge === 'Cloud-professional'" />
    <CloudAdvanced v-if="badge === 'Cloud-advanced'" />
    <CloudNovice v-if="badge === 'Cloud-novice'" />
    <CyberSecurityExpert v-if="badge === 'Cyber Security-expert'" />
    <CyberSecurityProfessional v-if="badge === 'Cyber Security-professional'" />
    <CyberSecurityAdvanced v-if="badge === 'Cyber Security-advanced'" />
    <CyberSecurityNovice v-if="badge === 'Cyber Security-novice'" />
  </div>
</template>
<script>
import NetworkingExpert from '@/assets/images/lab-experience/networking-expert.svg'
import NetworkingProfessional from '@/assets/images/lab-experience/networking-professional.svg'
import NetworkingAdvanced from '@/assets/images/lab-experience/networking-advanced.svg'
import NetworkingNovice from '@/assets/images/lab-experience/networking-novice.svg'

import CloudExpert from '@/assets/images/lab-experience/cloud-expert.svg'
import CloudProfessional from '@/assets/images/lab-experience/cloud-professional.svg'
import CloudAdvanced from '@/assets/images/lab-experience/cloud-advanced.svg'
import CloudNovice from '@/assets/images/lab-experience/cloud-novice.svg'

import CyberSecurityExpert from '@/assets/images/lab-experience/cyberSecurity-expert.svg'
import CyberSecurityProfessional from '@/assets/images/lab-experience/cyberSecurity-professional.svg'
import CyberSecurityAdvanced from '@/assets/images/lab-experience/cyberSecurity-advanced.svg'
import CyberSecurityNovice from '@/assets/images/lab-experience/cyberSecurity-novice.svg'

// TODO future improvements - conditionally color paths according to difficulty
// Something similar to DifficultyIcon.vue

export default {
  name: 'DifficultyLearningAreaIcon',
  components: {
    NetworkingExpert,
    NetworkingProfessional,
    NetworkingAdvanced,
    NetworkingNovice,
    CloudExpert,
    CloudProfessional,
    CloudAdvanced,
    CloudNovice,
    CyberSecurityExpert,
    CyberSecurityProfessional,
    CyberSecurityAdvanced,
    CyberSecurityNovice,
  },
  props: {
    difficulty: {
      type: String,
      required: true,
    },
    learningArea: {
      type: String,
      required: true,
    },
  },

  computed: {
    badge() {
      return `${this.learningArea}-${this.difficulty}`
    },
  },
}
</script>
<style lang="scss" scoped>
.difficulty-learning-area-icon {
  height: 100%;
  svg {
    height: inherit;
  }
}
</style>
